import React,{ useState, useEffect, useRef, useMemo } from 'react';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from "material-table";
import TableIcons from '../components/TableIcons';
import { tableOptions } from '../components/TableDefaults';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
  Modal,
  Grid,
  Typography,
  Box,
  MenuItem,
  Chip,
} from '@mui/material';
import {colors} from '../components/Theme/WebTheme';
import Button from "components/CustomButtons/Button.js";
import CancelIcon from '@mui/icons-material/Cancel';
import AlertDialog from '../components/AlertDialog';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PersonIcon from '@mui/icons-material/Person';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Menu from '@mui/material/Menu';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import UserPasswordDialog from '../components/UserPasswordDialog';
import DriverRegistrationDialog from '../components/DriverRegistrationDialog';

const useStyles = makeStyles((theme) => ({
  heading:{
   marginBottom: 20,
   height: '10%'
  },
  submit1: {
    marginLeft: 30
  },
  submit: {
    backgroundColor: '#2563EB',
    '&:hover': { backgroundColor: '#1D4ED8' },
  },
  submit5: {
    backgroundColor: '#111827',
    '&:hover': { backgroundColor: '#374151' },
  },
  submit3:{
    width: '100%',
    borderRadius: 12,
    marginTop: 8,
    padding: '12px 16px',
    fontWeight: 600,
    textTransform: 'none',
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 500,
    maxWidth: '95vw',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    padding: theme.spacing(3),
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  submit4:{
    backgroundColor: '#111827',
    width: '100%',
    borderRadius: 12,
    marginTop: 8,
    padding: '12px 16px',
    '&:hover': { backgroundColor: '#374151' },
  }
}));

export default function Users() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    fetchUsers,
    updateLicenseImage
  } = api;
  const [data, setData] = useState([]);
  const [cars, setCars] = useState({});
  const users = useSelector(state => state.usersdata.users);
  const cartypes = useSelector(state => state.cartypes);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const classes = useStyles();
  const rootRef = useRef(null);
  const [role, setRole] = useState(null);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();

  useEffect(()=>{
      // Real-time listener - updates instantly when data changes
      dispatch(fetchUsers());
  },[dispatch,fetchUsers]);

  useEffect(()=>{
    if(users){
        if(role === 'admin'){
          let arr =  users.filter(user => user.usertype==='fleetadmin');
          let obj = {}; 
          for(let i=0;i  < arr.length; i++){
              let user = arr[i];
              obj[user.id]=user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden");
          }
          setFleetAdminsObj(obj);
      }
      setTimeout(()=>{
        setData(users.filter(user => user.usertype ==='driver' && ((user.fleetadmin === auth.profile.uid && auth.profile.usertype === 'fleetadmin')|| auth.profile.usertype === 'admin')));
      },1000);
    }else{
      setData([]);
    }
    loaded.current = true;
  },[users,auth.profile.usertype,auth.profile.uid,settings.AllowCriticalEditsAdmin,role]);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(()=>{
    if(cartypes.cars){
        let obj =  {};
        cartypes.cars.map((car)=> obj[car.name]=car.name)
        setCars(obj);
    }
  },[cartypes.cars]);

  const [imageType, setImageType] = useState(null);

  const onClick = (rowData,text) => {

     if(text === 'licenseImage'){
      setImageType(text);
      setImageData(rowData.licenseImage);
    }
    else if(text === 'licenseImageBack'){
      setImageType(text);
      setImageData(rowData.licenseImageBack);
    }
    else if(text === 'verifyIdImage'){
      setImageType(text);
      setImageData(rowData.verifyIdImage);
    }
    setProfileModal(true);
    setUserData(rowData);
  };

  // Uber-style compact columns with status dots and action menu
  const columns = [
      { title: t('driver'), field: 'firstName',
        render: rowData => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {rowData.profile_image ? (
              <img alt='Profile' src={rowData.profile_image} style={{width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', border: '2px solid #F3F4F6'}}/>
            ) : (
              <Box sx={{ width: 44, height: 44, borderRadius: '50%', bgcolor: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <PersonIcon sx={{ color: '#9CA3AF', fontSize: 22 }} />
              </Box>
            )}
            <Box>
              <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>
                {rowData.firstName} {rowData.lastName}
              </Typography>
              <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
                {settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden"}
              </Typography>
            </Box>
          </Box>
        ),
        cellStyle: { padding: '14px 16px' },
      },
      { title: t('car_type'), field: 'carType', editable:'never',
        render: rowData => (
          <Typography sx={{ fontSize: 14, color: '#374151' }}>{rowData.carType || '-'}</Typography>
        ),
        cellStyle: { padding: '14px 16px' },
      },
      { title: t('vehicle_reg_no'), field: 'vehicleNumber', editable:'never',
        render: rowData => (
          <Typography sx={{ fontSize: 14, color: '#374151', fontFamily: 'monospace' }}>{rowData.vehicleNumber || '-'}</Typography>
        ),
        cellStyle: { padding: '14px 16px' },
      },
      { title: t('driver_active'), field: 'driverActiveStatus', type:'boolean',
        render: rowData => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FiberManualRecordIcon sx={{ fontSize: 10, color: rowData.driverActiveStatus ? '#10B981' : '#EF4444' }} />
            <Typography sx={{ fontSize: 14, color: '#374151' }}>
              {rowData.driverActiveStatus ? (t('active') || 'Active') : (t('inactive') || 'Inactive')}
            </Typography>
          </Box>
        ),
        cellStyle: { padding: '14px 16px' },
      },
      { title: t('account_approve'), field: 'approved', type:'boolean',
        render: rowData => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FiberManualRecordIcon sx={{ fontSize: 10, color: rowData.approved ? '#10B981' : '#F59E0B' }} />
            <Typography sx={{ fontSize: 14, color: '#374151' }}>
              {rowData.approved ? (t('approved') || 'Approved') : (t('pending') || 'Pending')}
            </Typography>
          </Box>
        ),
        cellStyle: { padding: '14px 16px' },
      },
      { title: t('actions'), field: 'action', sorting: false, editable: 'never',
        render: rowData => (
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <Tooltip title={t('view_details') || 'View details'}>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleActionClick(e, rowData);
                }}
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: 1.5,
                  bgcolor: '#F3F4F6',
                  '&:hover': { bgcolor: '#E5E7EB' },
                }}
              >
                <EditIcon sx={{ fontSize: 16, color: '#374151' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('delete') || 'Delete'}>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  if (settings.AllowCriticalEditsAdmin) {
                    if (window.confirm(t('delete_message') || 'Are you sure you want to delete?')) {
                      dispatch(deleteUser(rowData.id));
                    }
                  } else {
                    alert(t('demo_mode'));
                  }
                }}
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: 1.5,
                  bgcolor: '#FEE2E2',
                  '&:hover': { bgcolor: '#FECACA' },
                }}
              >
                <DeleteIcon sx={{ fontSize: 16, color: '#DC2626' }} />
              </IconButton>
            </Tooltip>
          </Box>
        ),
        cellStyle: { padding: '8px 16px', width: 100 },
        headerStyle: { width: 100 },
      },
  ];

  // Detail panel component for expandable row
  const DetailPanel = ({ rowData }) => (
    <Box sx={{ p: 3, bgcolor: '#F9FAFB', borderTop: '1px solid #E5E7EB' }}>
      <Grid container spacing={3}>
        {/* Personal Info */}
        <Grid item xs={12} md={4}>
          <Box sx={{ bgcolor: '#FFFFFF', p: 2, borderRadius: 2, border: '1px solid #E5E7EB' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <PersonIcon sx={{ color: '#2563EB' }} />
              <Typography sx={{ fontWeight: 600, color: '#111827' }}>{t('personal_info') || 'Personal Info'}</Typography>
            </Box>
            <Box sx={{ display: 'grid', gap: 1.5 }}>
              <DetailRow label={t('email')} value={settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden"} />
              <DetailRow label={t('mobile')} value={settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden"} />
              <DetailRow label={t('createdAt')} value={rowData.createdAt ? moment(rowData.createdAt).format('lll') : '-'} />
              <DetailRow label={t('wallet_balance')} value={rowData.walletBalance || '0'} />
              <DetailRow label={t('you_rated_text')} value={rowData.rating || '0'} />
              <DetailRow label={t('referralId')} value={rowData.referralId || '-'} />
              {rowData.signupViaReferral && <DetailRow label={t('signup_via_referral')} value={rowData.signupViaReferral} />}
            </Box>
          </Box>
        </Grid>

        {/* Vehicle Info */}
        <Grid item xs={12} md={4}>
          <Box sx={{ bgcolor: '#FFFFFF', p: 2, borderRadius: 2, border: '1px solid #E5E7EB' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <DirectionsCarIcon sx={{ color: '#2563EB' }} />
              <Typography sx={{ fontWeight: 600, color: '#111827' }}>{t('vehicle_info') || 'Vehicle Info'}</Typography>
            </Box>
            <Box sx={{ display: 'grid', gap: 1.5 }}>
              <DetailRow label={t('car_type')} value={rowData.carType || '-'} />
              <DetailRow label={t('vehicle_model_name')} value={rowData.vehicleMake || '-'} />
              <DetailRow label={t('vehicle_model_no')} value={rowData.vehicleModel || '-'} />
              <DetailRow label={t('vehicle_reg_no')} value={rowData.vehicleNumber || '-'} />
              <DetailRow label={t('car_approval')} value={rowData.carApproved ? '✓ Approved' : '✗ Pending'} />
              {rowData.other_info && <DetailRow label={t('other_info')} value={rowData.other_info} />}
            </Box>
          </Box>
        </Grid>

        {/* Documents & Banking */}
        <Grid item xs={12} md={4}>
          <Box sx={{ bgcolor: '#FFFFFF', p: 2, borderRadius: 2, border: '1px solid #E5E7EB' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <VerifiedUserIcon sx={{ color: '#2563EB' }} />
              <Typography sx={{ fontWeight: 600, color: '#111827' }}>{t('documents') || 'Documents & Banking'}</Typography>
            </Box>
            <Box sx={{ display: 'grid', gap: 1.5 }}>
              <DetailRow label={t('verify_id')} value={rowData.verifyId || '-'} />
              {settings.bank_fields !== false && (
                <>
                  <DetailRow label={t('bankName')} value={rowData.bankName || '-'} />
                  <DetailRow label={t('bankCode')} value={rowData.bankCode || '-'} />
                  <DetailRow label={t('bankAccount')} value={rowData.bankAccount || '-'} />
                </>
              )}
              {role === 'admin' && rowData.fleetadmin && (
                <DetailRow label={t('fleetadmins')} value={fleetAdminsObj?.[rowData.fleetadmin] || '-'} />
              )}
            </Box>
            {/* Document Images */}
            <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {rowData.licenseImage && (
                <Box
                  component="button"
                  onClick={() => onClick(rowData, 'licenseImage')}
                  sx={{ border: '1px solid #E5E7EB', borderRadius: 1, p: 0.5, cursor: 'pointer', bgcolor: 'transparent' }}
                >
                  <img alt='License Front' src={rowData.licenseImage} style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }} />
                </Box>
              )}
              {rowData.licenseImageBack && (
                <Box
                  component="button"
                  onClick={() => onClick(rowData, 'licenseImageBack')}
                  sx={{ border: '1px solid #E5E7EB', borderRadius: 1, p: 0.5, cursor: 'pointer', bgcolor: 'transparent' }}
                >
                  <img alt='License Back' src={rowData.licenseImageBack} style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }} />
                </Box>
              )}
              {rowData.verifyIdImage && (
                <Box
                  component="button"
                  onClick={() => onClick(rowData, 'verifyIdImage')}
                  sx={{ border: '1px solid #E5E7EB', borderRadius: 1, p: 0.5, cursor: 'pointer', bgcolor: 'transparent' }}
                >
                  <img alt='ID' src={rowData.verifyIdImage} style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }} />
                </Box>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );

  // Helper component for detail rows
  const DetailRow = ({ label, value }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{label}</Typography>
      <Typography sx={{ fontSize: 13, fontWeight: 500, color: '#111827', textAlign: 'right', maxWidth: '60%', wordBreak: 'break-word' }}>{value}</Typography>
    </Box>
  );

  const [profileModal, setProfileModal] =  useState(false);
  const [imageData, setImageData] =  useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [loading, setLoading] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null); 
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  }

  const [userData, setUserData] = useState();

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleSetProfileModal = (e) =>{
    e.preventDefault();
      if(selectedImage){
        setLoading(true);
        dispatch(updateLicenseImage(userData.id, selectedImage, imageType));
        setProfileModal(false);
        setSelectedImage(null);
        setTimeout(()=>{
          setLoading(false);
          // Real-time listener will auto-update
        },10000);
      }
      else{
        setCommonAlert({ open: true, msg: t('choose_image_first') })
      }
  }

  const [selectedRow, setSelectedRow] = useState(null);

  // Filter states
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterApproved, setFilterApproved] = useState('all');
  const [filterCarType, setFilterCarType] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Menu anchors for pill filters
  const [statusAnchor, setStatusAnchor] = useState(null);
  const [approvalAnchor, setApprovalAnchor] = useState(null);
  const [carTypeAnchor, setCarTypeAnchor] = useState(null);

  // Action menu state
  const [actionAnchor, setActionAnchor] = useState(null);
  const [actionRow, setActionRow] = useState(null);

  // Password dialog state
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const [passwordDialogUser, setPasswordDialogUser] = useState(null);

  // Registration dialog state
  const [registrationDialogOpen, setRegistrationDialogOpen] = useState(false);

  // Filtered data based on filters and search
  const filteredData = useMemo(() => {
    let result = data;
    if (filterStatus !== 'all') {
      result = result.filter(d => filterStatus === 'active' ? d.driverActiveStatus : !d.driverActiveStatus);
    }
    if (filterApproved !== 'all') {
      result = result.filter(d => filterApproved === 'approved' ? d.approved : !d.approved);
    }
    if (filterCarType !== 'all') {
      result = result.filter(d => d.carType === filterCarType);
    }
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      result = result.filter(d =>
        (d.firstName && d.firstName.toLowerCase().includes(query)) ||
        (d.lastName && d.lastName.toLowerCase().includes(query)) ||
        (d.email && d.email.toLowerCase().includes(query)) ||
        (d.mobile && d.mobile.toLowerCase().includes(query)) ||
        (d.vehicleNumber && d.vehicleNumber.toLowerCase().includes(query))
      );
    }
    return result;
  }, [data, filterStatus, filterApproved, filterCarType, searchQuery]);

  const clearFilters = () => {
    setFilterStatus('all');
    setFilterApproved('all');
    setFilterCarType('all');
    setSearchQuery('');
  };

  // Get filter label for pill buttons
  const getStatusLabel = () => {
    if (filterStatus === 'all') return t('status') || 'Status';
    return filterStatus === 'active' ? t('active') || 'Active' : t('inactive') || 'Inactive';
  };
  const getApprovalLabel = () => {
    if (filterApproved === 'all') return t('approval') || 'Approval';
    return filterApproved === 'approved' ? t('approved') || 'Approved' : t('pending') || 'Pending';
  };
  const getCarTypeLabel = () => {
    if (filterCarType === 'all') return t('car_type') || 'Car Type';
    return filterCarType;
  };

  // Handle action menu
  const handleActionClick = (event, rowData) => {
    event.stopPropagation();
    setActionAnchor(event.currentTarget);
    setActionRow(rowData);
  };
  const handleActionClose = () => {
    setActionAnchor(null);
    setActionRow(null);
  };

  return (
    !loaded.current? <CircularLoading/>:
    <div style={{backgroundColor:colors.LandingPage_Background}}>

    {/* Uber-Style Filter Toolbar */}
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        p: 2,
        mb: 2,
        bgcolor: '#FFFFFF',
        borderRadius: 3,
        border: '1px solid #E5E7EB',
        alignItems: 'center',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      }}
    >
      {/* Search Input */}
      <TextField
        size="small"
        placeholder={t('search') || 'Search drivers...'}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{
          minWidth: 220,
          '& .MuiOutlinedInput-root': {
            borderRadius: 50,
            bgcolor: '#F7F7F7',
            '& fieldset': { border: 'none' },
            '&:hover': { bgcolor: '#EFEFEF' },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: '#6B7280', fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
      />

      {/* Divider */}
      <Box sx={{ width: 1, height: 24, bgcolor: '#E5E7EB', mx: 1 }} />

      {/* All Pill */}
      <Chip
        label={t('all') || 'All'}
        onClick={clearFilters}
        sx={{
          bgcolor: filterStatus === 'all' && filterApproved === 'all' && filterCarType === 'all' ? '#111827' : '#F7F7F7',
          color: filterStatus === 'all' && filterApproved === 'all' && filterCarType === 'all' ? '#FFFFFF' : '#374151',
          fontWeight: 500,
          fontSize: 13,
          height: 36,
          borderRadius: 50,
          px: 1,
          cursor: 'pointer',
          '&:hover': {
            bgcolor: filterStatus === 'all' && filterApproved === 'all' && filterCarType === 'all' ? '#000000' : '#EFEFEF',
          },
        }}
      />

      {/* Status Pill */}
      <Chip
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {filterStatus !== 'all' && (
              <FiberManualRecordIcon sx={{ fontSize: 8, color: filterStatus === 'active' ? '#10B981' : '#EF4444' }} />
            )}
            {getStatusLabel()}
            <ExpandMoreIcon sx={{ fontSize: 16, ml: 0.5 }} />
          </Box>
        }
        onClick={(e) => setStatusAnchor(e.currentTarget)}
        sx={{
          bgcolor: filterStatus !== 'all' ? '#111827' : '#F7F7F7',
          color: filterStatus !== 'all' ? '#FFFFFF' : '#374151',
          fontWeight: 500,
          fontSize: 13,
          height: 36,
          borderRadius: 50,
          px: 1,
          cursor: 'pointer',
          '&:hover': { bgcolor: filterStatus !== 'all' ? '#000000' : '#EFEFEF' },
        }}
      />
      <Menu
        anchorEl={statusAnchor}
        open={Boolean(statusAnchor)}
        onClose={() => setStatusAnchor(null)}
        PaperProps={{ sx: { borderRadius: 2, mt: 1, minWidth: 150, boxShadow: '0 4px 20px rgba(0,0,0,0.15)' } }}
      >
        <MenuItem onClick={() => { setFilterStatus('all'); setStatusAnchor(null); }}>
          <Typography sx={{ fontSize: 14 }}>{t('all') || 'All'}</Typography>
        </MenuItem>
        <MenuItem onClick={() => { setFilterStatus('active'); setStatusAnchor(null); }}>
          <FiberManualRecordIcon sx={{ fontSize: 10, color: '#10B981', mr: 1 }} />
          <Typography sx={{ fontSize: 14 }}>{t('active') || 'Active'}</Typography>
        </MenuItem>
        <MenuItem onClick={() => { setFilterStatus('inactive'); setStatusAnchor(null); }}>
          <FiberManualRecordIcon sx={{ fontSize: 10, color: '#EF4444', mr: 1 }} />
          <Typography sx={{ fontSize: 14 }}>{t('inactive') || 'Inactive'}</Typography>
        </MenuItem>
      </Menu>

      {/* Approval Pill */}
      <Chip
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {filterApproved !== 'all' && (
              <FiberManualRecordIcon sx={{ fontSize: 8, color: filterApproved === 'approved' ? '#10B981' : '#F59E0B' }} />
            )}
            {getApprovalLabel()}
            <ExpandMoreIcon sx={{ fontSize: 16, ml: 0.5 }} />
          </Box>
        }
        onClick={(e) => setApprovalAnchor(e.currentTarget)}
        sx={{
          bgcolor: filterApproved !== 'all' ? '#111827' : '#F7F7F7',
          color: filterApproved !== 'all' ? '#FFFFFF' : '#374151',
          fontWeight: 500,
          fontSize: 13,
          height: 36,
          borderRadius: 50,
          px: 1,
          cursor: 'pointer',
          '&:hover': { bgcolor: filterApproved !== 'all' ? '#000000' : '#EFEFEF' },
        }}
      />
      <Menu
        anchorEl={approvalAnchor}
        open={Boolean(approvalAnchor)}
        onClose={() => setApprovalAnchor(null)}
        PaperProps={{ sx: { borderRadius: 2, mt: 1, minWidth: 150, boxShadow: '0 4px 20px rgba(0,0,0,0.15)' } }}
      >
        <MenuItem onClick={() => { setFilterApproved('all'); setApprovalAnchor(null); }}>
          <Typography sx={{ fontSize: 14 }}>{t('all') || 'All'}</Typography>
        </MenuItem>
        <MenuItem onClick={() => { setFilterApproved('approved'); setApprovalAnchor(null); }}>
          <FiberManualRecordIcon sx={{ fontSize: 10, color: '#10B981', mr: 1 }} />
          <Typography sx={{ fontSize: 14 }}>{t('approved') || 'Approved'}</Typography>
        </MenuItem>
        <MenuItem onClick={() => { setFilterApproved('pending'); setApprovalAnchor(null); }}>
          <FiberManualRecordIcon sx={{ fontSize: 10, color: '#F59E0B', mr: 1 }} />
          <Typography sx={{ fontSize: 14 }}>{t('pending') || 'Pending'}</Typography>
        </MenuItem>
      </Menu>

      {/* Car Type Pill */}
      <Chip
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {getCarTypeLabel()}
            <ExpandMoreIcon sx={{ fontSize: 16, ml: 0.5 }} />
          </Box>
        }
        onClick={(e) => setCarTypeAnchor(e.currentTarget)}
        sx={{
          bgcolor: filterCarType !== 'all' ? '#111827' : '#F7F7F7',
          color: filterCarType !== 'all' ? '#FFFFFF' : '#374151',
          fontWeight: 500,
          fontSize: 13,
          height: 36,
          borderRadius: 50,
          px: 1,
          cursor: 'pointer',
          '&:hover': { bgcolor: filterCarType !== 'all' ? '#000000' : '#EFEFEF' },
        }}
      />
      <Menu
        anchorEl={carTypeAnchor}
        open={Boolean(carTypeAnchor)}
        onClose={() => setCarTypeAnchor(null)}
        PaperProps={{ sx: { borderRadius: 2, mt: 1, minWidth: 150, boxShadow: '0 4px 20px rgba(0,0,0,0.15)' } }}
      >
        <MenuItem onClick={() => { setFilterCarType('all'); setCarTypeAnchor(null); }}>
          <Typography sx={{ fontSize: 14 }}>{t('all') || 'All'}</Typography>
        </MenuItem>
        {Object.keys(cars).map((carType) => (
          <MenuItem key={carType} onClick={() => { setFilterCarType(carType); setCarTypeAnchor(null); }}>
            <DirectionsCarIcon sx={{ fontSize: 16, color: '#6B7280', mr: 1 }} />
            <Typography sx={{ fontSize: 14 }}>{carType}</Typography>
          </MenuItem>
        ))}
      </Menu>

      {/* Results Count - Right aligned */}
      <Typography sx={{ ml: 'auto', fontSize: 13, color: '#6B7280' }}>
        {filteredData.length} {t('drivers') || 'drivers'}
      </Typography>

      {/* Add Driver Button */}
      <Button
        onClick={() => setRegistrationDialogOpen(true)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2.5,
          py: 1,
          borderRadius: 50,
          bgcolor: '#111827',
          color: '#FFFFFF',
          fontWeight: 600,
          fontSize: 13,
          textTransform: 'none',
          '&:hover': {
            bgcolor: '#000000',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
          transition: 'all 0.2s ease',
        }}
      >
        <AddIcon sx={{ fontSize: 18 }} />
        {t('add_driver') || 'Add Driver'}
      </Button>
    </Box>

    <MaterialTable
      icons={TableIcons}
      title={null}
      columns={columns}
      style={{
        direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
        borderRadius: 12,
        boxShadow: 'none',
        border: '1px solid #E5E7EB',
        overflow: 'hidden',
      }}
      data={filteredData}
      detailPanel={[
        {
          icon: () => <ExpandMoreIcon sx={{ color: '#6B7280' }} />,
          openIcon: () => <ExpandLessIcon sx={{ color: '#111827' }} />,
          tooltip: t('show_details') || 'Show Details',
          render: rowData => <DetailPanel rowData={rowData} />,
        }
      ]}
      onRowClick={(event, rowData, togglePanel) => {
        // Don't toggle if clicking on action button
        if (event.target.closest('button')) return;
        setSelectedRow(rowData.tableData.id);
        togglePanel();
      }}
      options={{
        ...tableOptions,
        search: false, // Using our own search
        toolbar: true, // Enable toolbar to show add button
        showTitle: false,
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' '+ new Date(row.createdAt).toLocaleTimeString();
            row.fleetadmin = row.fleetadmin?fleetAdminsObj[row.fleetadmin]:'';
            let dArr = [];
            for(let i=0;i< hArray.length; i++) {
              dArr.push(row[hArray[i]]);
            }
            return Object.values(dArr);
          })
          const { exportDelimiter } = ",";
          const delimiter = exportDelimiter ? exportDelimiter : ",";
          const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        maxColumnSort: "all_columns",
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ? '#F3F4F6' : '#fff'
        }),
      }}
      localization={{body:{
        addTooltip: (t('add')),
        deleteTooltip: (t('delete')),
        editTooltip: (t('edit')),
        emptyDataSourceMessage: (
          (t('blank_message'))
      ),
      editRow: { 
        deleteText: (t('delete_message')),
        cancelTooltip: (t('cancel')),
        saveTooltip: (t('save')) 
          }, 
        },
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        header: {
          actions: (t('actions')) 
      },
      pagination: {
        labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
        //labelRowsSelect: (t('rows')),
        firstTooltip: (t('first_page_tooltip')),
        previousTooltip: (t('previous_page_tooltip')),
        nextTooltip: (t('next_page_tooltip')),
        lastTooltip: (t('last_page_tooltip'))
      },
      }}
      editable={{
        onRowAdd: newData =>
        new Promise((resolve,reject) => {
          setTimeout(() => {
            checkUserExists(newData).then((res) => {
              if (res.users && res.users.length > 0) {
                alert(t('user_exists'));
                reject();
              }
              else if(!(newData && newData.firstName)){
                alert(t('proper_input_name'));
                reject();
              }
              else if(res.error){
                alert(t('email_or_mobile_issue'));
                reject();
              }
              else if(newData.licenseImage === '' || !newData.licenseImage){
                alert(t('proper_input_licenseimage'));
                reject();
              }
              else if(newData.licenseImageBack === '' || !newData.licenseImageBack){
                alert(t('proper_input_licenseimage'));
                reject();
              }
              else if( settings && settings.imageIdApproval && (newData.verifyIdImage === '' || !newData.verifyIdImage)){
                alert(t('upload_id_details'));
                reject();
              }
              else if( settings && settings.imageIdApproval && !newData.verifyId){
                alert(t('upload_id_details'));
                reject();
              }
              else{
                newData['usertype'] = 'driver';
                newData['createdAt'] = new Date().getTime();
                const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
                const reference = [...Array(5)].map(_ => c[~~(Math.random()*c.length)]).join('');
                newData['referralId'] = reference;
                let role = auth.profile.usertype;
                if(role === 'fleetadmin'){
                  newData['fleetadmin'] = auth.profile.uid;
                }
                dispatch(addUser(newData));
                // Real-time listener will auto-update
                resolve();
              }
            });
          }, 600);
        }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve,reject) => {
            setTimeout(() => {
              if(!(newData && newData.firstName)){
                alert(t('proper_input_name'));
                reject();
              }else if(!(newData && newData.licenseImage)){
                alert(t('proper_input_licenseimage'));
                reject();
              } else if( settings && settings.imageIdApproval && (newData.verifyIdImage === '' || !newData.verifyIdImage)){
                alert(t('upload_id_details'));
                reject();
              }
              else if( settings && settings.imageIdApproval && !newData.verifyId){
                alert(t('upload_id_details'));
                reject();
              }
              else{
                resolve();
                if(newData !== oldData){
                  delete newData.tableData;
                  dispatch(editUser(oldData.id,newData));
                  // Real-time listener will auto-update
                }
              }
            }, 600);
          }),
        onRowDelete: oldData =>
          settings.AllowCriticalEditsAdmin?
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              dispatch(deleteUser(oldData.id));
              // Real-time listener will auto-update
            }, 600);
          })
          :
          new Promise(resolve => {
            setTimeout(() => {
              resolve();
              alert(t('demo_mode'));
            }, 600);
          })
          ,
      }}
    />

    {/* Action Menu */}
    <Menu
      anchorEl={actionAnchor}
      open={Boolean(actionAnchor)}
      onClose={handleActionClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          mt: 0.5,
          minWidth: 180,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        }
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem
        onClick={() => {
          if (actionRow) {
            // Trigger MaterialTable edit mode - open the detail panel to show edit info
            handleActionClose();
          }
        }}
        sx={{ py: 1.5, px: 2 }}
      >
        <ListItemIcon>
          <EditIcon sx={{ fontSize: 18, color: '#374151' }} />
        </ListItemIcon>
        <ListItemText>
          <Typography sx={{ fontSize: 14 }}>{t('edit') || 'Edit driver'}</Typography>
        </ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (actionRow) {
            setPasswordDialogUser(actionRow);
            setPasswordDialogOpen(true);
            handleActionClose();
          }
        }}
        sx={{ py: 1.5, px: 2 }}
      >
        <ListItemIcon>
          <LockIcon sx={{ fontSize: 18, color: '#667eea' }} />
        </ListItemIcon>
        <ListItemText>
          <Typography sx={{ fontSize: 14 }}>Set Password & Username</Typography>
        </ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (actionRow && settings.AllowCriticalEditsAdmin) {
            dispatch(deleteUser(actionRow.id));
          } else {
            alert(t('demo_mode'));
          }
          handleActionClose();
        }}
        sx={{ py: 1.5, px: 2, color: '#DC2626' }}
      >
        <ListItemIcon>
          <DeleteIcon sx={{ fontSize: 18, color: '#DC2626' }} />
        </ListItemIcon>
        <ListItemText>
          <Typography sx={{ fontSize: 14, color: '#DC2626' }}>{t('delete') || 'Remove driver'}</Typography>
        </ListItemText>
      </MenuItem>
    </Menu>

    {/* Password Management Dialog */}
    <UserPasswordDialog
      open={passwordDialogOpen}
      onClose={() => setPasswordDialogOpen(false)}
      user={passwordDialogUser}
      onSuccess={(data) => {
        // Refresh data or show success message
        setCommonAlert({ open: true, msg: 'Password and login credentials updated successfully!' });
      }}
    />

    {/* Driver Registration Dialog */}
    <DriverRegistrationDialog
      open={registrationDialogOpen}
      onClose={() => setRegistrationDialogOpen(false)}
      onSuccess={(driverData) => {
        dispatch(addUser(driverData));
        setRegistrationDialogOpen(false);
        setCommonAlert({ open: true, msg: 'Driver registered successfully!' });
      }}
      carTypes={Object.keys(cars)}
      fleetAdmin={role === 'fleetadmin' ? auth.profile.uid : null}
      settings={settings}
    />

     <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={1} className={classes.paper} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography component="h1" variant="h6">
                      {t('license_image')}
                      <input
                          type="file"
                          style={{marginLeft:10}}
                          name= {t('image')}
                          onChange={(event) => {
                              setSelectedImage(event.target.files[0]);
                          }}
                      />
                </Typography>
              </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage  && !loading ? 
                    <Tooltip title={t('cancel')}>
                      <CancelIcon onClick={()=>setSelectedImage(null)} style={{ fontSize: 30,backgroundColor:'#1a1a1a',borderRadius:50,color:'#ffffff' }}  />
                    </Tooltip>
                  : null }
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    {selectedImage ? 
                      <img alt="not fount" height={"200px"} src={URL.createObjectURL(selectedImage)} style={{marginTop:15,marginBottom:20}}/>
                    :
                      <img alt="licimage" height={"200px"} src={imageData} style={{marginTop:10}}/>
                    }
                    <br />
                  </Grid>
                
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            {loading ? 
            <Grid
              container
              spacing={0}
              alignItems="center"
              justify="center"
              style={{ minHeight: '5vh' }} >
              <CircularProgress/>
            </Grid>
            :
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            <Button onClick={handleProfileModal} variant="contained" color="danger">
            {t('cancel')}
          </Button> 
            <Button onClick={handleSetProfileModal} variant="contained" color="secondaryButton" style={{marginLeft:10}}>
              {t('save')}
            </Button>
            </Grid>
            }
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </div>
  );
}
